module.exports = function(){


    window.styleAdviceTooltips;




    var enableTooltips = function(){

        window.styleAdviceTooltips = $('[js-style-advice-popup]').jBox('Tooltip', {
            //getTitle: 'data-jbox-title',
            getContent: 'js-style-advice-popup',
        });

        console.dir(styleAdviceTooltips);

    };




    var disableTooltips = function(){

        if (window.styleAdviceTooltips) {
            window.styleAdviceTooltips.destroy();
        }

    };





    if ( typeof Cookies.get('style_advice_enabled') !== 'undefined' ) {

        var enabled = Cookies.get('style_advice_enabled') == 'true';
        var disabled = Cookies.get('style_advice_enabled') == 'false';

        if (enabled) {
            $('[js-style-advice]').prop('checked', true);
            enableTooltips();
        }

        if (disabled) {
            $('[js-style-advice]').prop('checked', false);
            disableTooltips();
        }

    } else {
        enableTooltips();
    }




    $(document).on('change', '[js-style-advice]', function(event) {

        if ( $(this).prop('checked') ) {
            enableTooltips();
            Cookies.set('style_advice_enabled', 'true', {expires: 30});
        } else {
            disableTooltips();
            Cookies.set('style_advice_enabled', 'false', {expires: 30});
        }
    });




}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/integration/style-advice.js